import React from 'react'

export default function SuntTeaserListView(props) {
  const { 
    id = 1 
  } = props 
  return (
    <>
      <div id={`nativendo-start${id}`}></div>
    </>
  )
}